import { render, staticRenderFns } from "./CustomerOnetimeOrdersCreate.vue?vue&type=template&id=23817ebe&scoped=true"
import script from "./CustomerOnetimeOrdersCreate.vue?vue&type=script&lang=js"
export * from "./CustomerOnetimeOrdersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23817ebe",
  null
  
)

export default component.exports